import Box from "@mui/material/Box";
import {
    Button,
    Card,
    CardActions,
    CardContent, Grid,
    Stack,
    Typography
} from "@mui/material";


export default function LiquidityCard() {


    return <Card sx={{padding:"10px"}}>
        <CardContent>
            <Box sx={{width: '100%'}}>
                <Stack spacing={2}>
                    <Typography sx={{fontSize: 20}} color="text.secondary" gutterBottom>
                        USDC - APTOS
                    </Typography>

                    <Box sx={{ width: '100%' }}>
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={6}>
                                Total Deposits
                            </Grid>
                            <Grid item xs={6}>
                                APTOS 256 (US$5,847,816)
                            </Grid>

                        </Grid>
                    </Box>

                </Stack>
            </Box>
        </CardContent>
        <CardActions>
            <Button  fullWidth variant="contained" disableElevation>
                Deposit
            </Button>
        </CardActions>
    </Card>
}